import React, { Component, Fragment } from 'react';
import { Row } from 'react-bootstrap';
import cns from 'classnames';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import Image from '../../components/Image';
import { LEARNING_ASSET_DURATIONS } from '../../Constants';
import { overlayImageIds } from '../../utils/ImageUtils';
import circleCheck from '../../../../images/circle-check.svg';
import circleQuarter from '../../../../images/circle-quarter.svg';
import circlePlay from '../../../../images/circle-play.svg';
import locked from '../../../../images/lock-solid.svg';



class MobileUserCollectionLearningAssetRow extends Component {
    static propTypes = {
        userLearningAsset: PropTypes.object,
        isLocked: PropTypes.bool,
        isLockedReflection: PropTypes.bool,
        goToUserLearningAsset: PropTypes.func,
        hideDivider: PropTypes.bool,
        isReflection: PropTypes.bool,
        status: PropTypes.string
    };

    constructor(props) {
        super(props);
        this.state = {
            showCallToAction: false
        };
    }

    _getCompleteness = () => {
        const { userLearningAsset, isLocked } = this.props;
        const { status = '' } = userLearningAsset;

        if (isLocked || status === 'Locked' ) {
            return 'Locked';
        }
        if (status !== 'ASSIGNED') {
            const completeness = get(userLearningAsset, 'completeness', 0);
            if (completeness === 100 || get(userLearningAsset, 'isCompleted', false) === true) {
                return 'Done';
            }
            if (completeness > 0 && completeness < 100) {
                return 'In-progress';
            }
        }
        return 'Not Started';
    };

    _onClick = () => {
        this.setState({
            showCallToAction: !this.state.showCallToAction
        });
    };

    render() {
        const {
            userLearningAsset,
            goToUserLearningAsset,
            isLocked,
            isLockedReflection,
            hideDivider = false,
            isReflection = false,
            status = ''
        } = this.props;
        const learningAssetDuration = LEARNING_ASSET_DURATIONS();
        const assetCompleteness = this._getCompleteness();
        const isStartedReflection = ['IN_PROGRESS', 'COMPLETED'].includes(status);
        let assetType = 'ACTIVITY';

        if (userLearningAsset && userLearningAsset.type) {
            assetType = userLearningAsset.type.toUpperCase();
        }

        if (userLearningAsset && userLearningAsset.typeLabel && userLearningAsset.typeLabel !== 'NO_LABEL') {
            assetType = userLearningAsset.typeLabel.toUpperCase();
        }

        const durationId =
            userLearningAsset && userLearningAsset.track && userLearningAsset.track.durationId
                ? userLearningAsset.track.durationId
                : '';

        const durationIdForUnstartedActivity =
            userLearningAsset && userLearningAsset.durationId
                ? userLearningAsset.durationId
                : '';

        let overlayProps = {};
        let onClickHandler = () => {
            if (!isReflection || isStartedReflection) {
                goToUserLearningAsset(userLearningAsset._id);
            }
        };

        if (isLocked) {
            overlayProps = {
                overlayId: overlayImageIds.locked,
                dimension: {
                    h: 250,
                    w: 250
                }
            };
            onClickHandler = null;
        }
        const notStartedClass = !isStartedReflection && isReflection ? { notStarted: true } : {};

        const srcImage = get(userLearningAsset, 'track.thumbnailImageUrl', '') || get(userLearningAsset, 'thumbnailImageUrl', '');
        const activityName = get(userLearningAsset, 'track.name', '') || get(userLearningAsset, 'name', '');
        const activitySubtitle = get(userLearningAsset, 'track.subtitle', '') || get(userLearningAsset, 'subtitle', '');

        let completenessIcon = circlePlay;

        if (assetCompleteness === 'Done') {
            completenessIcon = circleCheck;
        } else if (assetCompleteness === 'In-progress') {
            completenessIcon = circleQuarter;
        } else if (assetCompleteness === 'Locked') {
            completenessIcon = locked;
        }

        return (
            <Row
                className={cns('asset-row', {
                    locked: isLocked,
                    unlocked: !isLocked,
                    lockedReflection: isLockedReflection,
                    hideDivider,
                    ...notStartedClass
                })}
                onClick={onClickHandler}
            >
                <div className={'asset-panel'}>
                    <div className='d-flex' style={{marginRight: 16}}>
                        <Image
                            src={srcImage}
                            className={'asset-thumbnail'}
                            overlay={overlayProps}
                            dimension={{ h: 250, w: 250 }}
                            cloudinaryCrop={'fill'}
                            quality={{ q: 100 }}
                        />
                        <div className='d-flex justify-content-start flex-column' style={{marginLeft: 16, paddingRight: 16}}>
                            <h4 className={'asset-name'}>{activityName}</h4>
                            <p className={'asset-description'}>{activitySubtitle}</p>
                            <div className='d-flex justify-content-start flex-row' style={{marginTop: 4}}>
                                <div className={'icon-container duration d-sm-flex'}>
                                    <i className={'asset-duration-icon fal fa-fw fa-clock duration-icon'} />
                                    <h5 className={'asset-duration'}>
                                        {get(learningAssetDuration[durationId || durationIdForUnstartedActivity], 'label', '')}
                                    </h5>
                                </div>
                                { (<div className={'icon-container completeness d-sm-flex'}>
                                    <img
                                        src={completenessIcon}
                                        alt={'Progress Icon'}
                                        className={'asset-completeness-icon'}
                                    />
                                    <span className={cns('asset-completeness', assetCompleteness)}>
                                        {assetCompleteness === 'Locked' && !isLockedReflection ? '' : assetCompleteness}
                                    </span>
                                </div>)}
                            </div>
                        </div>
                    </div>
                </div>
            </Row>
        );
    }
}

export default MobileUserCollectionLearningAssetRow;
